<script setup lang="ts">
  import { ref } from 'vue'
  import ContactUsWidget from '@/widgets/ContactUsWidget/ContactUsWidget.vue'
  import NeedHelpButton from './components/NeedHelpButton/NeedHelpButton.vue'
  import { useFlow, useFlowSteps, useGoogleAnalytics } from '@/shared/composables'
  import { useRoute } from 'vue-router'

  const gaService = useGoogleAnalytics()
  const flow = useFlow()
  const route = useRoute()
  const flowStep = useFlowSteps(flow.flowScheme)
  const popupShown = ref<boolean>(false)

  const onShowHelpPopup = () => {
    popupShown.value = true
    gaService.sendContactUsPopup(flowStep.step.value.current || route.name)
  }
</script>

<template>
  <NeedHelpButton @click="onShowHelpPopup" />
  <ContactUsWidget
    v-model="popupShown"
    :page="flowStep.step.value.current"
    data-test="need-help-widget"
  />
</template>
